import VariantHelper from './VariantHelper'
import type { FooterSelectorProps } from '../../types'

export const FooterSelector = ({
  variant = 'verticalAlignedButtons',
  ...rest
}: FooterSelectorProps) => VariantHelper[variant](rest)
